import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=33a7767b&scoped=true"
var script = {}
import style0 from "./Department.vue?vue&type=style&index=0&id=33a7767b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a7767b",
  null
  
)

export default component.exports